import React, { useState } from "react";
import "../styles/ContactUs.css";

const ContactUs = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [pdfFile, setPdfFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      if (file.size > 30 * 1024 * 1024) {
        setErrors((prev) => ({
          ...prev,
          pdfFile: "File size must be under 30MB.",
        }));
        setPdfFile(null);
      } else {
        setPdfFile(file);
        setErrors((prev) => ({ ...prev, pdfFile: null }));
      }
    } else {
      setPdfFile(null);
      setErrors((prev) => ({
        ...prev,
        pdfFile: "Only PDF files are allowed.",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = "Name is required.";
    if (!form.email.trim()) newErrors.email = "Email is required.";
    else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(form.email))
      newErrors.email = "Invalid email format.";
    if (!form.message.trim()) newErrors.message = "Message is required.";
    // if (!pdfFile) newErrors.pdfFile = "Please upload a PDF document.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    console.log("clicked");
    
    e.preventDefault();
    if (!validateForm()) return;

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("phone", form.phone);
    formData.append("message", form.message);
    formData.append("pdfFile", pdfFile);

    try {
      const res = await fetch("https://kingdomhomesapi.onrender.com/api/contact-form", {
          method: "POST",
          body: formData,
        }
      );
      console.log("Sending form data:", {
        ...formData,
        file: pdfFile?.name,
      });
      if (res.ok) {
        setSubmitted(true);
        setForm("");
        console.log(setSubmitted);

        console.log("Email sent");
      } else {
        console.error("Failed to send");
      }
    } catch (err) {
      console.error("Error submitting:", err);
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-heading-area">
        <h2 className="section-title">Contact Us</h2>
        <p className="section-subtitle">
          We'd love to hear about your project.
        </p>
      </div>

      <div className="contact-grid">
        {/* Contact Form */}
        <div className="contact-form-wrapper">
          <form onSubmit={handleSubmit} className="contact-form">
            <label>
              Name<span className="required">*</span>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
              />
              {errors.name && <span className="error">{errors.name}</span>}
            </label>

            <label>
              Email<span className="required">*</span>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
              />
              {errors.email && <span className="error">{errors.email}</span>}
            </label>

            <label>
              Phone
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="(Optional)"
              />
            </label>

            <label>
              Message<span className="required">*</span>
              <textarea
                name="message"
                rows="5"
                value={form.message}
                onChange={handleChange}
                placeholder="Tell us about your project..."
              />
              {errors.message && (
                <span className="error">{errors.message}</span>
              )}
            </label>

            <label>
              Upload PDF
              <input
                type="file"
                accept="application/pdf"
                onChange={handleFileChange}
              />
              {errors.pdfFile && (
                <span className="error">{errors.pdfFile}</span>
              )}
              {pdfFile && (
                <p className="file-preview">Selected: {pdfFile.name}</p>
              )}
            </label>

            <button
              type="submit"
              className="submit-button"
              disabled={submitted}
            >
              {submitted ? "Submitted" : "Send Message"}
            </button>

            {submitted && (
              <p className="success-message">
                Thank you! We'll be in touch shortly.
              </p>
            )}
          </form>
        </div>

        {/* Office Information */}
        <div className="contact-info-wrapper">
          <h3 className="info-title">Let’s Chat!</h3>
          <p className="info-description">
            Reach out via form or call us directly. We're here to help with all
            your project needs.
          </p>

          <div className="office-info-card full-card">
            <h4 className="office-title">The Gold Standard in Luxury Living</h4>
            <p className="office-address">
              C-64, 2nd Floor, RDC Rajnagar, Ghaziabad, Uttar Pradesh - 201002
            </p>
            <p className="office-contact">
              <a href="tel:+918882711036">📞 +91-8882711036</a>
              <br />
              <a href="mailto:Info@kingdomhomes.in">✉️ Info@kingdomhomes.in</a>
            </p>

            {/* 🗺️ Google Maps Embed */}
            <div className="office-map">
              <iframe
                title="Kingdom Homes Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14017.657622387314!2d77.43850452523259!3d28.671734213878498!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf11c3e6f7c5b%3A0x4f4cecd7137e7ebf!2sRDC%20Raj%20Nagar%2C%20Ghaziabad%2C%20Uttar%20Pradesh%20201002!5e0!3m2!1sen!2sin!4v1731149868403!5m2!1sen!2sin"
                width="100%"
                height="250"
                style={{ border: 0, borderRadius: "10px", marginTop: "10px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <p className="recaptcha-note">
        Protected by reCAPTCHA. See Google's{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>{" "}
        and{" "}
        <a
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noreferrer"
        >
          Terms of Service
        </a>
        .
      </p>
    </section>
  );
};

export default ContactUs;
